import { useFormContext } from 'react-hook-form'
import { Trans, useTranslation } from 'react-i18next'

import { GapBox } from 'components/Box'
import { BoxForm, CodeField, NumberField } from 'components/Form'
import { SectionHeader } from 'components/Header'
import { Link } from 'components/Link'
import Paper from 'components/Paper'
import { useAbility } from 'providers/casl'
import { KNOWLEDGE_BASE_URL } from '../constants'
import { Schema } from '../schema'

export const AdvancedPrebidSection = (): React.JSX.Element => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'defaults.prebid.advancedPrebidSettings',
  })
  const { t: tC } = useTranslation('common')
  const { control } = useFormContext<Schema>()

  const ability = useAbility()
  const cannotUpdate: boolean = ability.cannot('update', 'GlobalSetupFeature-defaults-prebidStack')

  return (
    <Paper>
      <SectionHeader
        subtitle={t('subtitle')}
        title={t('title')}
      />

      <GapBox />

      <BoxForm>
        <NumberField
          control={control}
          disabled={cannotUpdate}
          label={t('auctionDelay.label')}
          name='auctionDelay'
          tooltip={{
            content: t('auctionDelay.tooltip'),
            link: {
              title: tC('learnMore'),
              url: KNOWLEDGE_BASE_URL.TIMEOUTS,
            },
          }}
        />

        <NumberField
          control={control}
          disabled={cannotUpdate}
          label={t('syncsPerBidder.label')}
          name='syncsPerBidder'
          tooltip={{
            content: (
              <Trans
                components={{
                  url: (
                    <Link
                      newTab
                      to={KNOWLEDGE_BASE_URL.USER_SYNC}
                    />
                  ),
                }}
                i18nKey='syncsPerBidder.tooltip'
                t={t}
              />
            ),
          }}
        />

        <NumberField
          control={control}
          disabled={cannotUpdate}
          label={t('syncDelay.label')}
          name='syncDelay'
          tooltip={{
            content: (
              <Trans
                components={{
                  url: (
                    <Link
                      newTab
                      to={KNOWLEDGE_BASE_URL.USER_SYNC}
                    />
                  ),
                }}
                i18nKey='syncDelay.tooltip'
                t={t}
              />
            ),
          }}
        />

        <CodeField
          control={control}
          disabled={cannotUpdate}
          language='javascript'
          name='allowActivitiesData'
          options={{ renderValidationDecorations: 'off' }}
          title={t('allowActivitiesData.label')}
          tooltip={{
            content: t('allowActivitiesData.tooltip'),
            link: {
              title: tC('learnMore'),
              url: KNOWLEDGE_BASE_URL.ALLOW_ACTIVITIES,
            },
          }}
        />

        <CodeField
          control={control}
          disabled={cannotUpdate}
          language='json'
          name='prebidCustomConfig'
          title={t('prebidCustomConfig.label')}
          tooltip={{
            content: t('prebidCustomConfig.tooltip'),
          }}
        />
      </BoxForm>
    </Paper>
  )
}
